import React, { Component } from 'react';
import DRNText from '../../standard/Text/DRNText';
import { View, StyleSheet } from 'react-native';
import PropTypes from 'prop-types';
import R from '../../core-res/R';
import { withTheme } from '../../theme';
class CellItem extends Component {
    constructor() {
        super(...arguments);
        this.renderCellText = () => {
            const { cellText, isTextSecondary, theme } = this.props;
            let style = { color: theme.textPrimary };
            if (isTextSecondary) {
                style = { color: theme.textSecondary };
            }
            return <DRNText style={[styles.text, style]}>{cellText}</DRNText>;
        };
    }
    render() {
        const { Icon, EndComponent, description, theme } = this.props;
        return (<View style={[styles.container, { borderColor: theme.lightNeutral }]}>
        <View style={styles.leftContainer}>
          {Icon && (<View style={styles.iconContainer}>
              <Icon />
            </View>)}
          <View style={styles.textContainer}>
            {this.renderCellText()}
            {!!description && (<DRNText style={[styles.descriptionText, { color: theme.textSecondary }]}>{description}</DRNText>)}
          </View>
        </View>
        {EndComponent && (<View style={styles.endComponent}>
            <EndComponent />
          </View>)}
      </View>);
    }
}
CellItem.propTypes = {
    cellText: PropTypes.string.isRequired,
    Icon: PropTypes.func,
    EndComponent: PropTypes.func,
    isTextSecondary: PropTypes.bool,
    description: PropTypes.string,
    theme: PropTypes.object,
};
CellItem.defaultProps = {
    isTextSecondary: false,
};
const styles = StyleSheet.create({
    container: {
        paddingHorizontal: R.spacing.m,
        paddingVertical: R.spacing.xs,
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottomWidth: R.border.width.thin,
    },
    leftContainer: {
        flexDirection: 'row',
        flex: 1,
    },
    text: Object.assign({}, R.typography.uiBaseline),
    iconContainer: {
        marginTop: R.spacing.xxs,
        marginRight: R.spacing.s,
    },
    descriptionText: Object.assign({}, R.typography.uiSmall),
    textContainer: {
        flex: 1,
        flexDirection: 'column',
    },
    endComponent: {
        marginTop: R.spacing.xxs,
    },
});
export default withTheme(CellItem);
